"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    formatedUserConsents: function() {
        return formatedUserConsents;
    },
    getConsentType: function() {
        return getConsentType;
    },
    getCookieConsentFormated: function() {
        return getCookieConsentFormated;
    },
    getDefaultPurposesConsents: function() {
        return getDefaultPurposesConsents;
    },
    getPurposesConsents: function() {
        return getPurposesConsents;
    },
    getUserConsents: function() {
        return getUserConsents;
    },
    getUserPurposesConsentFromNotice: function() {
        return getUserPurposesConsentFromNotice;
    },
    getUserPurposesConsents: function() {
        return getUserPurposesConsents;
    },
    sendUserConsentsToGTM: function() {
        return sendUserConsentsToGTM;
    }
});
var _define_property = require("@swc/helpers/_/_define_property");
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
var _to_consumable_array = require("@swc/helpers/_/_to_consumable_array");
var _purposes = require("./purposes");
var purposesKeys = Object.keys(_purposes.purposes);
var purposesList = Object.values(_purposes.purposes).reduce(function(acc, item) {
    var _obj;
    return _object_spread._((_obj = {}, _define_property._(_obj, item.category, "category"), _define_property._(_obj, item.short_name, "short_name"), _obj), acc);
}, {});
var isPurposeKey = function(key) {
    return purposesKeys.includes(key);
};
var getUserPurposesConsentFromNotice = function() {
    var _window_didomiState, _window;
    var purposeConsent = ((_window = window) === null || _window === void 0 ? void 0 : (_window_didomiState = _window.didomiState) === null || _window_didomiState === void 0 ? void 0 : _window_didomiState.didomiPurposesConsent) || "";
    var purposeConsentCleaned = typeof purposeConsent === "string" ? purposeConsent.replace(/,$/, "") : "";
    return purposeConsentCleaned;
};
/**
 * This method sends events to GTM
 * GTM is loaded by Rudderstack
 *
 * @return void
 */ var dataLayerPushEvent = function(eventObject) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventObject);
};
var getConsentType = function(consentName) {
    if (!consentName) {
        return undefined;
    }
    return purposesList[consentName];
};
var getCookieConsentFormated = function() {
    var returnType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "object";
    var cookiesConsents = getUserPurposesConsentFromNotice();
    var shoudReturnArray = returnType === "array";
    if (!cookiesConsents) {
        return shoudReturnArray ? [] : {};
    }
    var consentsArray = cookiesConsents.split(",").filter(isPurposeKey);
    return consentsArray.reduce(function(acc, consent) {
        var purposeConsent = _purposes.purposes[consent];
        if (shoudReturnArray) {
            return _to_consumable_array._(acc).concat([
                consent
            ]);
        }
        return _object_spread._({}, acc, purposeConsent && _define_property._({}, consent, _object_spread._({}, _purposes.purposes[consent])));
    }, shoudReturnArray ? [] : {});
};
var getPurposesConsents = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_filterBy = _ref.filterBy, filterBy = _ref_filterBy === void 0 ? "category" : _ref_filterBy, _ref_withDefaultValues = _ref.withDefaultValues, withDefaultValues = _ref_withDefaultValues === void 0 ? false : _ref_withDefaultValues;
    var cookiesConsents = getCookieConsentFormated();
    var allPurposes = withDefaultValues ? _purposes.purposes : cookiesConsents;
    return Object.keys(_purposes.purposes).filter(isPurposeKey).reduce(function(acc, purpose) {
        var currentPurpose = allPurposes[purpose];
        if (typeof currentPurpose === "undefined" || withDefaultValues) {
            return _object_spread_props._(_object_spread._({}, acc), _define_property._({}, _purposes.purposes[purpose][filterBy], !!_purposes.purposes[purpose].default_value));
        }
        if (currentPurpose[filterBy]) {
            return _object_spread_props._(_object_spread._({}, acc), _define_property._({}, currentPurpose[filterBy], true));
        }
        return acc;
    }, {});
};
var getDefaultPurposesConsents = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_filterBy = _ref.filterBy, filterBy = _ref_filterBy === void 0 ? "category" : _ref_filterBy;
    return getPurposesConsents({
        filterBy: filterBy,
        withDefaultValues: true
    });
};
var getUserPurposesConsents = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_filterBy = _ref.filterBy, filterBy = _ref_filterBy === void 0 ? "category" : _ref_filterBy;
    return getPurposesConsents({
        filterBy: filterBy,
        withDefaultValues: false
    });
};
var formatedUserConsents = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_filterBy = _ref.filterBy, filterBy = _ref_filterBy === void 0 ? "category" : _ref_filterBy;
    var cookiesConsents = getUserPurposesConsentFromNotice();
    var consentsArray = cookiesConsents.split(",").filter(Boolean);
    if (consentsArray.length === 0) {
        return getDefaultPurposesConsents({
            filterBy: filterBy
        });
    }
    return getUserPurposesConsents({
        filterBy: filterBy
    });
};
var sendUserConsentsToGTM = function() {
    var userId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var currentProposes = _purposes.purposes;
    var purposeKeys = getCookieConsentFormated("array");
    purposeKeys.forEach(function(purpose) {
        var eventObj = _define_property._({
            event: "jt_event_constent_".concat(currentProposes[purpose].short_name)
        }, "jt_user_consent_purpose_".concat(currentProposes[purpose].short_name), true);
        dataLayerPushEvent(eventObj);
    });
    if (userId) {
        dataLayerPushEvent({
            jtCurrentUserId: userId
        });
    }
};
function getUserConsents(purpose) {
    var typeOfConsent = getConsentType(purpose);
    var userConsents = formatedUserConsents({
        filterBy: typeOfConsent
    });
    if (typeof purpose === "string") {
        return !!userConsents[purpose];
    }
    return userConsents;
}

//# sourceMappingURL=utils.js.map